import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import SmartImage from 'dpl/components/SmartImage';

import BylineNames from './BylineNames';

const AUTHOR_IMAGE_DIAMETER = '40px';

export default function Byline({ authors }) {
  const avatarUrls = authors.map(a => get(a, 'avatar.url')).filter(Boolean);

  return (
    <div className="PrismicByline flex items-center f0">
      {avatarUrls.map((avatarUrl, idx) => (
        <SmartImage
          key={idx}
          Tag="div"
          src={avatarUrl}
          width={AUTHOR_IMAGE_DIAMETER}
          height={AUTHOR_IMAGE_DIAMETER}
          className="bg-center cover br-100 mr2"
          lazy
        />
      ))}
      <p className="f1">
        By <BylineNames authors={authors} />
      </p>
    </div>
  );
}

Byline.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string,
      avatar: PropTypes.shape({
        url: PropTypes.string
      })
    })
  ).isRequired
};
